import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { usersAPI } from "./api";
import { logout } from "../auth";
import { createMiddleware } from "../middlewareUtil";

const initialState = {
  loading: false,
  loaded: false,
  updating: false,
  updated: false,
  list: [],
};

export const loadUsers = createAsyncThunk(
  "users/loadUsers",
  async (_, { getState, dispatch, rejectWithValue }) => {
    const accessToken = getState().auth.accessCode;

    if (!accessToken) {
      return rejectWithValue("No access token available");
    }

    const result = await usersAPI.loadUsers(accessToken);

    if (result.success) {
      return result.data;
    } else if (result.error === "unauthorized") {
      dispatch(logout());
      return rejectWithValue("Authentication failed");
    }

    return rejectWithValue("Failed to load users");
  }
);

// Create the slice
const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    reset: () => cloneDeep(initialState),
  },
  extraReducers: (builder) => {
    builder
      // Load users
      .addCase(loadUsers.pending, (state) => {
        state.loading = true;
        state.loaded = false;
        state.updating = false;
        state.updated = false;
      })
      .addCase(loadUsers.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
        state.loaded = true;
        state.updating = false;
        state.updated = false;
      })
      .addCase(loadUsers.rejected, (state) => {
        state.list = [];
        state.loading = false;
        state.loaded = false;
        state.updating = false;
        state.updated = false;
      });
  },
});

// This middleware is used to refresh the token when the user is loading the list of
// users. It will check if the token is expired and refresh it if needed.

// add the action types that use the access token to have it automatically refreshed
export const usersMiddleware = createMiddleware(["users/loadUsers/pending"]);

export const { reset } = usersSlice.actions;

export default usersSlice.reducer;
